import { render, staticRenderFns } from "./LanguageSelection.vue?vue&type=template&id=c529bf5a"
import script from "./LanguageSelection.vue?vue&type=script&lang=js"
export * from "./LanguageSelection.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelection.vue?vue&type=style&index=0&id=c529bf5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports